import { LineChart } from "@mui/x-charts";

import styles from "./ChartView.module.scss";

export interface ChartViewProps {
  xAxisData?: string | Date[];
  data?: number[];
  label?: string;
  titleTop?: string;
  titleRight?: string;
  title?: string;
  valueMax?: number;
  handleNextWindow?: () => void;
  handlePrevWindow?: () => void;
  unit?: string;
}

export default function ChartLineView({
  xAxisData = [],
  data = [],
  label,
  title,
  titleTop,
  titleRight,
  handleNextWindow,
  handlePrevWindow,
  unit,
}: ChartViewProps) {
  const unitFormat = unit ? " " + unit : "";
  const axisColors = ["#848484"];
  return (
    <div className={styles["chart"]}>
      <LineChart
        xAxis={[{ scaleType: "utc", data: xAxisData as Date[] }]}
        series={[
          {
            data: data,
            valueFormatter: (value) =>
              value == null ? "NaN" : value.toString() + unitFormat,
            showMark: ({ index }) => false,
          },
        ]}
        height={200}
        margin={{ top: 10, bottom: 20 }}
        colors={["#4CAF50"]}
        slotProps={{
          axisLine: { style: { stroke: axisColors[0] } },
          axisTick: { style: { stroke: axisColors[0] } },
          axisLabel: { style: { fill: axisColors[0] } },
          axisTickLabel: { style: { fill: axisColors[0] } },
        }}
      />
    </div>
  );
}
